import React from 'react'
import { connect } from 'react-redux'
import { reduxForm, getFormValues, Field, SubmissionError } from 'redux-form'
import { Button } from 'semantic-ui-react'
import { Dialog, DialogTitle, DialogContent, DialogActions } from '@material-ui/core'
import FieldInput, { InputType as type } from 'components/SemanticForm'
import { BranchFormContainer } from './styled'
import r from 'reactotron-react-js'

const BranchModalForm = (props) => {
  const { valueForm, handleSubmit, onSubmitBranch, showBranchModal, branchData, clearBranchData, listBranch } = props
  const isNew = branchData ? false : true

  React.useEffect(() => {
  }, [])

  const submitWithholdingTax = () => {
    var branchIsDuplicate = false
    if (isNew) {
      var b = listBranch.find(x => x.branchCode === valueForm.branchCode)

      if (b) branchIsDuplicate = true
    } else {
      if (branchData.branchCode !== valueForm.branchCode) {
        // Change branch
        var branch = listBranch.find(x => x.branchCode === valueForm.branchCode)
        if (branch) branchIsDuplicate = true
      }
    }

    if (!branchIsDuplicate) {
      onSubmitBranch(valueForm, isNew, branchData)
      if (!isNew) clearBranchData()
      showBranchModal(false)
    } else {
      throw new SubmissionError({ branchCode: 'This branch is duplicate!' })
    }
  }

  return (
    <Dialog open={true} maxWidth='sm' fullWidth style={{ zIndex: 10 }}>
      <DialogTitle>Branch</DialogTitle>
      <DialogContent>
        <form>
          <BranchFormContainer>
            <div className='rowFields'>
              <Field 
                name='branchCode' 
                label='Branch Code' 
                require
                type={type.text} 
                component={FieldInput} 
              />
              <Field 
                name='description' 
                label='Description' 
                require
                type={type.text} 
                component={FieldInput} 
              />
            </div>
            <div className='rowFields'>
              <Field name='defaultBranch' label='Default Branch' type={type.checkbox} component={FieldInput} />
            </div>
          </BranchFormContainer>
        </form>
      </DialogContent>
      <DialogActions>
        <form onSubmit={handleSubmit(values => submitWithholdingTax())}>
          <Button
            color='blue'
            content={isNew ? 'Add' : 'Save'}
            type='submit'
          />
          <Button
            color='red'
            content='Cancel'
            onClick={() => showBranchModal(false)}
          />
        </form>
      </DialogActions>
    </Dialog>
  )
}

const mapStateToProps = (state, props) => {
  const branchData = props.branchData || {}
  const listBranch = props.listBranch || []

  var initDefaultBranch = true
  
  if (listBranch.length > 0) {
    const defaultBrh = listBranch.find(b => b.defaultBranch === true)
    if (defaultBrh) initDefaultBranch = false
  }

  return ({
    valueForm: getFormValues('formBranch')(state),
    initialValues: {
      branchCode: branchData.branchCode || '',
      description: branchData.description || '',
      defaultBranch: branchData.defaultBranch || initDefaultBranch
    }
  })
}
  
const mapDispatchToProps = {
}

const validate = (values) => {
  const errors = {}
  if (!values.branchCode) errors.branchCode = 'Require!'
  if (!values.description) errors.description = 'Require!'

  return errors
}

const BranchForm = reduxForm({
  form: 'formBranch',
  enableReinitialize: true,
  validate
})(BranchModalForm)

export default connect(mapStateToProps, mapDispatchToProps)(BranchForm)